import ModalContainer, { ModalContainerProps } from "components/common/ModalContainer";
import React, { useMemo, useState } from "react";
import { ForecastNewProductContentProps } from "./types/ForecastNewProductStepForm";
import Button from "components/common/Button";
import { FORECAST_NEW_PRODUCT_STEP } from "./constant/ForecastNewProductStepConstant";
import clsx from "clsx";

import ProgressBar from "components/common/ProgressBar";
import { useCancelNewProductPlan } from "hooks/newProductPlanHooks";
import { newProductPlanActions } from "redux/Ldb/actions";
import { useAppDispatch } from "hooks/storeHooks";
import { useSearchParams } from "react-router-dom";
import { useChannel } from "ably/react";

type ForecastNewProductPlanProgressModalProps = {} & ForecastNewProductContentProps &
    Omit<ModalContainerProps, "children">;

export default function ForecastNewProductPlanProgressModal(
    props: ForecastNewProductPlanProgressModalProps
) {
    const { tailwindClassName, stepper, formik, ...rest } = props;
    const dispatch = useAppDispatch();
    const [_, setSearchParams] = useSearchParams();
    const [newProductPlanSyncProgress, setNewProductPlanSyncProgress] = useState<
        Map<string, Record<string, number>>
    >(new Map());

    const [cancelNewProductPlanMutation, cancelNewProductPlanMutationResult] =
        useCancelNewProductPlan();

    const handleCancel = async (productPlanId: string) => {
        await cancelNewProductPlanMutation(productPlanId);
        dispatch(newProductPlanActions.resetCancelNewProductPlan());
    };

    const ldbId = formik.values.similarProducts?.[0]?.ldbId;

    useChannel(
        `forecast`,
        useMemo(
            () => (syncRes) => {
                if (syncRes?.name === "newProductPlan") {
                    if (syncRes?.data?.ldbId === ldbId) {
                        setNewProductPlanSyncProgress((prev) => {
                            const newMap = new Map(prev);
                            newMap.set(syncRes?.data?.newProductPlanId, {
                                progress: syncRes?.data?.progress,
                                ldbId: syncRes?.data?.ldbId,
                            });
                            console.log("syncRes", { newMap });
                            return newMap;
                        });
                    }
                }
            },
            [ldbId]
        )
    );

    const similarProducts = formik?.values?.similarProducts
        ?.filter((product) => !!product?.productId)
        ?.map((product) => {
            console.log({
                product,
                progress: newProductPlanSyncProgress.get(product?._id),
            });
            return {
                ...product,
                progress:
                    newProductPlanSyncProgress.get(product?._id)?.progress ||
                    product?.progress ||
                    0,
            };
        });

    return (
        <ModalContainer
            {...rest}
            closeModal={() => {}}
            tailwindClassName={clsx("max-w-[600px]", tailwindClassName)}
        >
            <div>
                <div className="flex justify-between items-center px-[24px] py-[16px]">
                    <p className="text-[18px]  font-rocGroteskMedium">
                        New product forecast in progress
                    </p>

                    <button onClick={rest.closeModal}>
                        <i className="ri-close-line"></i>
                    </button>
                </div>

                <hr className="border-[#E2E8F0]" />

                <div className="px-[24px] py-[12px] bg-[#F8FAFC]">
                    <p className="text-[14px] text-[#64748B] font-[500] font-rocGroteskMedium leading-[20px]">
                        I am analyzing your data, identifying similar patterns, and applying the
                        most relevant forecasting models. This may take a few moments as I build the
                        most accurate plan based on your inputs and real-time context. you can close
                        this and this check back later
                    </p>
                </div>

                <div className="max-h-[500px] overflow-y-auto">
                    <div className="border border-[#F1F5F9] mx-[24px] mt-[24px] mb-[32px]">
                        {similarProducts?.length > 0 &&
                            similarProducts?.map((similarProduct, index) => (
                                <div>
                                    <div className="flex gap-4 px-[16px] py-[12px]">
                                        <div>
                                            <div
                                                className={clsx(
                                                    "flex items-center rounded-[4px] w-[36px] h-[36px] flex justify-center items-center",
                                                    similarProduct?.progress === 100
                                                        ? "bg-[#E6F6E6]"
                                                        : "bg-[#F1F5F9]"
                                                )}
                                            >
                                                <i
                                                    className={clsx(
                                                        "ri-box-2-fill  text-base",
                                                        similarProduct?.progress === 100
                                                            ? "text-[#0AAD0A]"
                                                            : "text-[#64748B]"
                                                    )}
                                                ></i>
                                            </div>
                                        </div>

                                        <div className="w-full">
                                            <div className="flex justify-between w-full">
                                                <p>{similarProduct?.productId?.split("-")[1]}</p>
                                                <p>{similarProduct?.progress}%</p>
                                            </div>

                                            <ProgressBar
                                                className="bg-carribean-green mt-1 !rounded-[5px]"
                                                progress={
                                                    newProductPlanSyncProgress.get(
                                                        similarProduct?._id
                                                    )?.progress || similarProduct?.progress
                                                }
                                            />
                                        </div>
                                        <div>
                                            {" "}
                                            <Button
                                                btnText="Cancel"
                                                btnClassname="!bg-[#F4F5F7] !px-[12px] !py-[6px]"
                                                isLoading={
                                                    cancelNewProductPlanMutationResult?.isLoading
                                                }
                                                onClick={() => {
                                                    handleCancel(similarProduct?._id);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={clsx(
                                            "border border-[#F1F5F9]",
                                            index !== formik?.values.similarProducts?.length - 1 &&
                                                "border-b-0"
                                        )}
                                    />
                                </div>
                            ))}

                        {similarProducts?.length === 0 && (
                            <div className="flex justify-center items-center h-[100px]">
                                <p className="text-[14px] text-[#64748B] font-[500] font-rocGroteskMedium leading-[20px]">
                                    No new product plans in progress
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                <hr className="border-[#E2E8F0]" />

                <div className="flex gap-[8px] px-[24px] py-[12px]">
                    <Button
                        btnText="Forecast new product"
                        onClick={() => {
                            setSearchParams({});
                            formik.resetForm();
                            stepper.go(FORECAST_NEW_PRODUCT_STEP.PLAN);
                        }}
                        btnClassname="!bg-white !border !border-n-20 !py-3 !pl-3 !pr-4 !w-fit !h-[48px]"
                        icon={<i className="ri-external-link-line text-lg"></i>}
                        btnType="textFirst"
                    />

                    <div className="flex-1"></div>
                    <Button
                        btnText="Cancel All"
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                        btnClassname="!bg-[#F4F5F7] cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                    <Button
                        btnText="Cancel"
                        onClick={() => {
                            rest.closeModal();
                        }}
                        btnClassname="!bg-[#FFB903] cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                </div>
            </div>
        </ModalContainer>
    );
}
